import { useRef, useState } from "react";
import { httpsCallable } from "firebase/functions";
import { staffDataChanged } from "./staffAccess";
import { functions } from "./firebase";

export async function registerUser(profile) {
  const response = await httpsCallable(functions, "createUserWithInvite", { timeout: 120000 })(profile);
  staffDataChanged();
  return response.data;
}
export function notifyRegistration(result, notify) {
  const status = result?.invitation?.status;
  if (status === "sent") notify("User registered; invitation email sent");
  else if (status === "inactive") notify("User created inactive; no invitation email sent");
  else notify("User registered, but the invitation could not be sent. Use the resend invitation icon to try again.", "error");
}
export function ResendInviteButton({ user, notify, style, children }) {
  const [sending, setSending] = useState(false), pending = useRef(false);
  const eligible = user.active !== false && ["admin", "treasurer", "superuser"].includes(user.role) && !!user.email;
  const resend = async () => {
    if (pending.current || !eligible) return;
    pending.current = true; setSending(true);
    try {
      await httpsCallable(functions, "resendUserInvite", { timeout: 120000 })({ userId: user.id });
      notify(`Invitation sent to ${user.email}`);
    } catch (error) { notify(error.message || "The invitation could not be sent. Please try again.", "error"); }
    finally { pending.current = false; setSending(false); }
  };
  return <button type="button" title={!eligible ? "Enable the user and provide an email before inviting" : sending ? "Sending invitation…" : "Resend invitation"}
    aria-label={`Resend invitation to ${user.name || user.email}`} aria-busy={sending} disabled={sending || !eligible}
    onClick={resend} style={{ ...style, minWidth: 36, minHeight: 36, opacity: sending || !eligible ? .5 : 1 }}>
    {sending ? "…" : children || "✉"}
  </button>;
}
